import React, { useRef } from "react";
import { Button } from "sulu-admin-bundle/components";

import MatchDayHeader from "./MatchDayHeader";
import MatchItem from "./MatchItem";
import formatISO from "date-fns/formatISO";
import {
  createGuidId,
  formatDataToSend,
  groupBy,
} from "../../utils/teams-dragger";

const Matches = ({ ...props }) => {
  const matchDivRef = useRef(null);

  const matches = Object.entries(
    groupBy(
      props.boardData.filter((r) => r.colType === "matches"),
      "identifier"
    )
  );

  const handleDateChange = (value, oldValue, identifier) => {
    const itemIndex = identifier?.split?.("*")?.[1];

    const newDate = new Date(new Date(value).setHours(0, 0, 0, 0));
    const formattedDate = formatISO(newDate, "yyyy-MM-dd");

    const newBoardData = props.boardData?.map((x) => {
      if (x?.identifier === identifier) {
        return {
          ...x,
          identifier: formattedDate + "*" + itemIndex,
          date: formattedDate,
        };
      }
      return x;
    });

    props.setBoardData(newBoardData);
    const newData = formatDataToSend(newBoardData);
    props.onChange(newData);
    props.onFinish();
  };

  const handleTimeChange = (value, board) => {
    let found = props.boardData.find((x) => x.id === board.id);
    const indexOf = props.boardData.indexOf(found);

    found = {
      ...found,
      time: formatISO(value, "yyyy-MM-dd[T]HH:mm"),
    };

    let newBoardData = [...props.boardData];

    newBoardData[indexOf] = found;
    props.setBoardData(newBoardData);

    const newData = formatDataToSend(newBoardData);
    props.onChange(newData);
    props.onFinish();
  };

  const onAddMatchRow = (key, identifier) => {
    const date = key
      ? formatISO(new Date(new Date(key).setHours(0, 0, 0, 0)), "yyyy-MM-dd")
      : null;
    const time = key ? formatISO(new Date(key), "yyyy-MM-dd[T]HH:mm") : null;

    const likeItems = props.boardData.reduce(
      (acc, v, i) => ({
        ...acc,
        [v?.identifier]: i,
      }),
      {}
    );

    const newIndexToInsertAt = likeItems?.[identifier] + 1;

    const newBoardData = [...props.boardData];
    newBoardData.splice(newIndexToInsertAt, 0, {
      id: createGuidId(),
      identifier: identifier,
      colType: "matches",
      date: date,
      time: time,
      // time: "",
      items: [],
    });

    const data = [...newBoardData];
    props.setBoardData(data);
    const newData = formatDataToSend(data);
    props.onChange(newData);
    props.onFinish();
  };

  const onAddMatchDay = () => {
    const newLength =
      props.boardData.filter((r) => r.colType === "matches")?.length + 1;

    const date = formatISO(
      new Date(new Date().setHours(0, 0, 0, 0)),
      "yyyy-MM-dd"
    );
    const time = formatISO(new Date(), "yyyy-MM-dd[T]HH:mm");

    const data = [
      ...props.boardData,
      {
        id: createGuidId(),
        identifier: "" + "*" + newLength,
        colType: "matches",
        date,
        time,
        items: [],
      },
    ];

    props.setBoardData(data);
    const newData = formatDataToSend(data);
    props.onChange(newData);
    props.onFinish();

    // matchDivRef.current.scrollIntoView({ behavior: "smooth" });
  };

  // return null;
  return (
    <div className="matches">
      {matches.map(([d, value], eIndex) => {
        const dateString = d?.split?.("*")?.[0];
        const date = dateString ? new Date(dateString) : dateString;
        const identifier = d;

        return (
          <div className="matches__main" key={eIndex}>
            <MatchDayHeader
              title={`${eIndex + 1}. Match Day`}
              date={date}
              handleDateChange={(v, e) => handleDateChange(v, date, identifier)}
            />

            {value.map((board, bIndex) => {
              return (
                <MatchItem
                  key={board.id}
                  board={board}
                  bIndex={bIndex}
                  identifier={identifier}
                  portal={props.portal}
                  date={date}
                  valueLength={value?.length}
                  handleTimeChange={handleTimeChange}
                  onAddMatchRow={onAddMatchRow}
                  deleteAction={() => {
                    const data = props.boardData.filter(
                      (x) => x.id !== board.id
                    );
                    props.setBoardData(data);
                    const newData = formatDataToSend(data);
                    props.onChange(newData);
                    props.onFinish();
                  }}
                />
              );
            })}
          </div>
        );
      })}

      {props.boardData.find((r) => r.colType === "teams")?.items?.length ? (
        <div className="matches__addmatchcontainer">
          <Button
            className="matches__addmatchday"
            skin="primary"
            onClick={onAddMatchDay}
          >
            add match day
          </Button>
        </div>
      ) : (
        <></>
      )}

      <div ref={matchDivRef} />
    </div>
  );
};

export default Matches;
